import React from 'react'

class Intro extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="intro intro--shortenMore">
        <div className="container">
          <div className="intro__content">
            <h1>College Scholarships</h1>
            <p>
              Today, esports is growing exponentially with 400 million fans worldwide who repeatedly pack out
              arenas. Currently, there are 200 colleges and universities offering almost 10 million dollars in
              scholarships. Establishing esports in high school enables students to do what they love and
              provides them with additional opportunities to earn scholastic recognition.
            </p>
          </div>
        </div>
        {/*<div className="intro__mask intro__mask--fadeToRight"></div>*/}
      </div>
    )
  }
}

export default Intro



// WEBPACK FOOTER //
// ./src/common/ui/components/IntroScholarships.js